export function getColor({ theme, disabled, stylingType, alignment, selected, active, focused, isActive, }) {
    if (disabled) {
        return `color: rgba(${theme.colors.transparentBlack},0.26);`;
    }
    if (active &&
        alignment !== "horizontal" &&
        (stylingType === "withIcon" || stylingType === "withIcons" || !stylingType)) {
        return `color: ${theme.colors.white};`;
    }
    if (focused && alignment === "vertical" && !stylingType) {
        return `color: ${theme.colors.black};`;
    }
    if ((selected || isActive) &&
        alignment !== "horizontal" &&
        (stylingType === "withIcon" || !stylingType)) {
        return `color: ${theme.colors.primaryLight};`;
    }
    return `color: ${theme.colors.black};`;
}
export function isWithTwoTextRows(stylingType) {
    const withTwoTextRow = stylingType === "withTwoTextRows" ||
        stylingType === "withStatus" ||
        stylingType === "withAdditionalElement";
    return withTwoTextRow;
}
export function isWithBackground(stylingType) {
    return (stylingType === "withBackground" ||
        stylingType === "withTwoTextRows" ||
        stylingType === "withStatus" ||
        stylingType === "withAdditionalElement");
}
export function getTabTitleHeight({ stylingType, isMultiLine, touchScreen, }) {
    if (isWithTwoTextRows(stylingType)) {
        return "3.75rem";
    }
    if (isWithBackground(stylingType)) {
        return "3rem";
    }
    if (isMultiLine) {
        return "auto";
    }
    if (touchScreen) {
        return "2.75rem";
    }
    return "2.5rem";
}
